import { Bar, BarChart, Cell, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { AXIS_TICK, CHART_COLORS, TOOLTIP_STYLE } from './theme';

interface SuccessRateChartProps {
  /** Both 0..1. */
  firstAttempt: number;
  eventual: number;
}

/** The project's thesis in one picture: what retrying is worth. */
export function SuccessRateChart({ firstAttempt, eventual }: SuccessRateChartProps) {
  const toPercent = (value: number): number =>
    Number.isFinite(value) ? Number((value * 100).toFixed(2)) : 0;

  const data = [
    { label: 'First attempt', Rate: toPercent(firstAttempt) },
    { label: 'Eventual', Rate: toPercent(eventual) },
  ];

  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={data} margin={{ top: 8, right: 8, bottom: 4, left: 0 }}>
        <CartesianGrid stroke={CHART_COLORS.grid} vertical={false} />
        <XAxis dataKey="label" tick={AXIS_TICK} tickLine={false} axisLine={{ stroke: CHART_COLORS.grid }} />
        <YAxis
          tick={AXIS_TICK}
          tickLine={false}
          axisLine={{ stroke: CHART_COLORS.grid }}
          domain={[0, 100]}
          width={44}
          unit="%"
        />
        <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: 'rgba(91,155,255,0.08)' }} />
        <Bar dataKey="Rate" unit="%" radius={[4, 4, 0, 0]} maxBarSize={80}>
          <Cell fill={CHART_COLORS.warning} />
          <Cell fill={CHART_COLORS.success} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
